module.exports = __webpack_public_path__ + "static/media/contact.ae563d30.jpg";